import { useState, useEffect } from "react";
import { MdFilterAlt } from "../../../assets/icons/vander";
import { useForm } from "../../../hooks";
import { usePatientSurgeryStore, useSelectOptionsStore } from "../../hooks";
import { InputGroupSearch } from "../../ui";
import { IoReload } from "react-icons/io5";
import { Select } from "../../ui";

const formValidations = {};

export const PatientSurgerySearchForm = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    filters,
    patientSurgeries,

    // Methods
    getSearch,
  } = usePatientSurgeryStore();

  const { patienSurgeryStates } = useSelectOptionsStore();

  // States ------------------------------------------------//
  const [formData, setFormData] = useState(filters);
  // Formulario --------------------------------------------//
  const { formState, onInputChange, onResetForm } = useForm(
    formData,
    formValidations
  );
  // Funciones ---------------------------------------------//
  const onSubmit = () => {
    getSearch(formState);
  };
  const handleSelectChange = (e) => {
    onInputChange(e);
    getSearch({ ...formState, [e.target.name]: e.target.value });
  };

  const onReset = () => {
    onResetForm({ search: "", state: "" });
    getSearch({ search: "", state: "" });
  };

  // Efectos -----------------------------------------------//
  return (
    <div className="vstack gap-3">
      <div className="row justify-content-between align-items-center">
        <div className="col-6">
          <div className="d-flex gap-4 align-items-center">
            <InputGroupSearch
              placeholder={`Busca pacientes`}
              name={`search`}
              value={formState.search}
              onInputChange={onInputChange}
              onSubmit={onSubmit}
            />
            <MdFilterAlt className="icon-sm text-gray-500" />
          </div>
        </div>
        <div className="col-3">
          <div className="d-flex justify-content-end text-gray-600 gap-3 align-items-center">
            <div>{patientSurgeries.data.length} Pacientes</div>
            <button
              className="btn btn-icon btn-pills btn-soft-primary"
              onClick={onReset}
            >
              <IoReload />
            </button>
          </div>
        </div>
      </div>
      <div>
        <Select
          label={"Estado"}
          name={"state"}
          options={patienSurgeryStates.data}
          labelKey={"label"}
          onInputChange={handleSelectChange}
          value={formState.state || ""}
        />
      </div>
    </div>
  );
};
